// export const BASE_URL = process.env.REACT_APP_BACKEND_URL ?? 'http://localhost:8080';
export const BASE_URL = 'https://sds3-renanlopes.herokuapp.com' ?? 'http://localhost:8080';


